<template>
  <div class="comp-score">
    <div class="score-title">竞争力</div>
    <div class="score-text">{{ score || '--' }}</div>
  </div>
</template>
<script>

export default {
  props: ['score'],
  data() {
    return {
    };
  },
  methods: {
  },
};
</script>

<style lang="scss" scoped>
  @import '~@/style/app-var.scss';

  .comp-score {
    display: flex;
    align-items: center;
    margin-left: 0.5rem;
    margin-top: 0.2rem;
    width: 4.3rem;
    min-width: 4.3rem;
    line-height: 1rem;
    height: 1rem;
  }

  .score-title {
    border: 0.05rem solid #5ED69C;
    border-radius: 0.2rem 0rem 0rem 0.2rem;
    font-size: 0.6rem;
    background-color: #0DC16A;
    color: #ffffff;
    text-align: center;
    width: 2.3rem;
    min-width: 2.3rem;
  }

  .score-text {
    border: 0.05rem solid #5ED69C;
    border-left: none;
    border-radius: 0rem 0.2rem 0.2rem 0rem;
    color: #0DC16A;
    font-size: 1rem;
    font-weight: bold;
    text-align: center;
    width: 2rem;
    min-width: 2rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/Competitiveness.vue